import Phaser from 'phaser';

export const SFX_TAP_KEY = 'sfx-tap';
export const SFX_SPIN_WHEEL_KEY = 'sfx-spin-wheel';
export const SFX_POINTS_KEY = 'sfx-points';
export const SFX_FINISH_KEY = 'sfx-finish';

type PickItUpSettings = {
  sound?: unknown;
};

export function isSoundEnabled(): boolean {
  try {
    const raw = localStorage.getItem('pickitup_settings');
    if (!raw) return true;
    const parsed = JSON.parse(raw) as PickItUpSettings;
    if (typeof parsed.sound === 'boolean') return parsed.sound;
  } catch {
    // ignore broken/missing localStorage data
  }
  return true;
}

export function playSfx(
  scene: Phaser.Scene,
  key: string,
  config?: Phaser.Types.Sound.SoundConfig,
): void {
  if (!isSoundEnabled()) return;
  if (!scene.sound || !scene.cache.audio.exists(key)) return;
  scene.sound.play(key, config);
}
